var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-video youtube"},[_c('iframe',{attrs:{"src":("//www.youtube.com/embed/" + (_vm.video.providerId)),"frameborder":"0","allowfullscreen":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }